module.exports = __webpack_public_path__ + "img/146-1e5581.png";